export default "__VITE_ASSET__6d32eb32__"